// extracted by mini-css-extract-plugin
export default {"container":"rF-z","modal":"sF-z","dimensions":"tF-z","brandName":"uF-z","productName":"vF-z","labelValue":"wF-z","recipientEmail":"xF-z","recommendedFit":"yF-z","hiddenField":"zF-z"};